import isEmpty from 'lodash/isEmpty'
import reduce from 'lodash/reduce'

export const filterEmpty = <T>(data: T) =>
  reduce(
    data || {},
    (acc, current, key) => {
      if ((typeof current !== 'boolean' && isEmpty(current)) || !String(current).trim()) {
        return acc
      }

      return { ...acc, [key]: current }
    },
    {}
  ) as unknown as T
